<div class="bg-lightest h-full flex place-content-center">
  <div class="px-4 lg:w-1/2 mt-4 md:mt-10">
    <h1 class="flex flex-row justify-center text-3xl md:text-4xl mb-5 md:mb-10 font-app-bold p-4">
      {{ "strongAuthentication.title" | translate }}
    </h1>
    <div class="bg-white rounded-lg border-lightest border shadow-none px-5 pt-5 pb-10">
      <h2 class="text-xl font-app-bold mb-3 text-center">
        {{ "strongAuthentication.strongAuthentText" | translate }}
      </h2>
      <p-divider type="solid"></p-divider>
      <p class="text-center mb-7 whitespace-break-spaces">
        {{ "strongAuthentication.mfaCodeText" | translate }}
        <span class="font-app-bold">{{ email }}.</span>
      </p>
      <form
        [formGroup]="formGroup"
        class="flex flex-col"
        (ngSubmit)="onSubmit()">
        <p-inputOtp
          formControlName="code"
          [integerOnly]="true"
          [length]="6"
          placeholder="Saisissez le code"
          class="w-full mt-1 p-5 rounded-md mb-5 place-content-center h-5 border-none"
          required></p-inputOtp>
        <small class="text-center justify-center mb-5 text-medium_light text-xs">
          {{ "strongAuthentication.mfaRedeemCodeText1" | translate }}
          <a
            *ngIf="!isLoading"
            href="javascript:void(0);"
            (click)="resendCode()"
            class="text-primary font-bold underline">
            {{ "strongAuthentication.mfaRedeemCodeText2" | translate }}
          </a>
          <p-progressSpinner
            class="ml-3"
            ariaLabel="loading"
            styleClass="w-5 h-5"
            strokeWidth="3"
            *ngIf="isLoading" />
        </small>
        <small
          *ngIf="isLoading"
          class="text-center justify-center mb-5 font-app-medium text-green text-xs"
          >{{ "strongAuthentication.mfaRedeemCodeTextEmail" | translate
          }}<i class="pi pi-check text-green ml-1 text-sm"></i
        ></small>
        <button
          pButton
          label="Valider le code"
          (click)="onSubmit()"
          class="rounded-md py-3 px-5 bg-primary text-white text-center cursor-pointer w-1/2 mx-auto"
          [disabled]="!formGroup.valid"></button>
      </form>
    </div>
  </div>
</div>
<p-toast></p-toast>

